
import { InjectionToken } from '@angular/core';
export interface OnvidaWrapperConfig {
    OnvidaWrapper: any;
    IsWrapper: boolean;
}
export const WindowsWrapper= new InjectionToken<OnvidaWrapperConfig>('app.config description');
 